export default __webpack_public_path__ + "img/0df32d2539e3bfca601427932126de26.png";